import { useQuery } from '@tanstack/react-query';
import { EVENT_QUERY_KEYS } from '../../../../../../../../constants/queryKeys';
import EventApiV2 from '../../../../../../../../lib/api/event/EventApiV2';
import { EventProductItemV2 } from '../../../../../../../../types/event/product';

const useEventProductList = (id: number) => {
  const { data } = useQuery([...EVENT_QUERY_KEYS.DETAIL, id], () => EventApiV2.getEventDetail(id), {
    enabled: !!id,
    select: (res) => res.event.eventItems.map((item) => new EventProductItemV2(item)),
  });

  return data || [];
};

export default useEventProductList;
